<template>
    <LoadingComponent :props="loading" />

    <div id="restaurant_state" class="db-card db-tab-div active" :class="{ 'on-update': onUpdateActive }">
        <div class="db-card-header items-center justify-between gap-4">
            <h3 class="db-card-title">{{ $t("menu.whatsapp_order_setup") }}</h3>
        
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
        <div class="db-card-body pt-3">
            <form @submit.prevent="save" class="w-full">
                <div class="form-row">
                    <!-- Driver selector al inicio -->
                    <div class="form-col-12">
                        <label class="db-field-title required">{{ $t('label.whatsapp_driver') }}</label>
                        <div class="db-field-radio-group">
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" id="driver_standard" class="custom-radio-field"
                                        :value="'standard'" v-model="form.whatsapp_driver">
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="driver_standard" class="db-field-label">{{ $t('label.whatsapp_standard') }}</label>
                            </div>
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" id="driver_business" class="custom-radio-field"
                                        :value="'business'" v-model="form.whatsapp_driver">
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="driver_business" class="db-field-label">{{ $t('label.whatsapp_business') }}</label>
                            </div>
                        </div>
                    </div>

                    <!-- Configuración en el medio -->
                    <div class="form-col-12 sm:form-col-6 lg:form-col-4">
                        <label for="whatsapp_number" class="db-field-title required">
                            {{ $t("label.whatsapp_number") }}
                        </label>

                        <div :class="errors.whatsapp_number ? 'invalid' : ''"
                            class="db-field-control flex items-center">
                            <div class="w-fit flex-shrink-0 dropdown-group">
                                <button type="button" class="flex items-center gap-1 dropdown-btn">
                                    {{ flag }}
                                    <span class="whitespace-nowrap flex-shrink-0 text-xs">{{
                                        form.whatsapp_calling_code
                                    }}</span>
                                    <i class="fa-solid fa-caret-down text-xs"></i>
                                </button>
                                <ul
                                    class="p-1.5 w-24 rounded-lg shadow-xl absolute top-8 -left-4 z-10 border border-gray-200 bg-white scale-y-0 origin-top dropdown-list !h-52 !overflow-x-hidden !overflow-y-auto thin-scrolling">
                                    <li v-for="countryCode in countryCodes" @click="change(countryCode)"
                                        class="flex items-center gap-2 p-1.5 rounded-md cursor-pointer hover:bg-gray-100">
                                        {{ countryCode.flag_emoji }}
                                        <span class="whitespace-nowrap text-xs">{{ countryCode.calling_code
                                            }}</span>
                                    </li>
                                </ul>

                            </div>
                            <input v-model="form.whatsapp_number" v-on:keypress="phoneNumber($event)" v-bind:class="errors.whatsapp_number
                                ? 'invalid' : ''" type="text" id="phone" class="pl-2 text-sm w-full h-full" />
                        </div>

                        <small class="db-field-alert" v-if="errors.whatsapp_number">{{ errors.whatsapp_number[0]
                            }}</small>
                    </div>

                    <!-- Business Cloud API fields (si el driver es business) -->
                    <div v-if="form.whatsapp_driver === 'business'" class="form-col-12 sm:form-col-6 lg:form-col-4">
                        <label class="db-field-title">{{ $t('label.whatsapp_business_phone_number_id') }}</label>
                        <input type="text" v-model="form.whatsapp_business_phone_number_id" class="db-field-control"
                            :class="errors.whatsapp_business_phone_number_id ? 'invalid' : ''" />
                        <small class="db-field-alert" v-if="errors.whatsapp_business_phone_number_id">{{ errors.whatsapp_business_phone_number_id[0] }}</small>
                    </div>
                    <div v-if="form.whatsapp_driver === 'business'" class="form-col-12 sm:form-col-6 lg:form-col-4">
                        <label class="db-field-title">{{ $t('label.whatsapp_business_waba_id') }}</label>
                        <input type="text" v-model="form.whatsapp_business_waba_id" class="db-field-control"
                            :class="errors.whatsapp_business_waba_id ? 'invalid' : ''" />
                        <small class="db-field-alert" v-if="errors.whatsapp_business_waba_id">{{ errors.whatsapp_business_waba_id[0] }}</small>
                    </div>
                    <div v-if="form.whatsapp_driver === 'business'" class="form-col-12 sm:form-col-6 lg:form-col-4">
                        <label class="db-field-title">{{ $t('label.whatsapp_business_app_id') }}</label>
                        <input type="text" v-model="form.whatsapp_business_app_id" class="db-field-control"
                            :class="errors.whatsapp_business_app_id ? 'invalid' : ''" />
                        <small class="db-field-alert" v-if="errors.whatsapp_business_app_id">{{ errors.whatsapp_business_app_id[0] }}</small>
                    </div>
                    <!-- Graph API base URL (ejemplo: https://graph.facebook.com/v25.0) -->
                    <div v-if="form.whatsapp_driver === 'business'" class="form-col-12 sm:form-col-6 lg:form-col-8">
                        <label class="db-field-title">{{ $t('label.whatsapp_graph_base_url') }}</label>
                        <input type="text" v-model="form.whatsapp_graph_base_url" class="db-field-control"
                            placeholder="ej. https://graph.facebook.com/v25.0"
                            :class="errors.whatsapp_graph_base_url ? 'invalid' : ''" />
                        <small class="db-field-alert" v-if="errors.whatsapp_graph_base_url">{{ errors.whatsapp_graph_base_url[0] }}</small>
                    </div>
                    <div v-if="form.whatsapp_driver === 'business'" class="form-col-12">
                        <label class="db-field-title">{{ $t('label.whatsapp_business_access_token') }}</label>
                        <input type="text" v-model="form.whatsapp_business_access_token" class="db-field-control"
                            :class="errors.whatsapp_business_access_token ? 'invalid' : ''" />
                        <small class="db-field-alert" v-if="errors.whatsapp_business_access_token">{{ errors.whatsapp_business_access_token[0] }}</small>
                    </div>

                    <!-- Status al final -->
                    <div class="form-col-12">
                        <label class="db-field-title required">{{ $t("label.status") }}</label>
                        <div class="db-field-radio-group">
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" v-model="form.whatsapp_status" id="open"
                                        :value="enums.activityEnum.ENABLE" class="custom-radio-field">
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="open" class="db-field-label">{{ $t('label.enable') }}</label>
                            </div>
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" v-model="form.whatsapp_status" id="close"
                                        :value="enums.activityEnum.DISABLE" class="custom-radio-field">
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="close" class="db-field-label">{{ $t('label.disable') }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-col-12 border-t pt-5 mt-3">
                        <button type="submit" class="db-btn text-white bg-primary" :disabled="isSaving">
                            <template v-if="isSaving">
                                <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                    <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                </svg>
                                <span>{{ $t('button.updating') }}</span>
                            </template>
                            <template v-else>
                                <i class="lab lab-fill-save"></i>
                                <span>{{ $t("button.save") }}</span>
                            </template>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import alertService from "../../../../services/alertService";
import appService from "../../../../services/appService";
import activityEnum from "../../../../enums/modules/activityEnum";

export default {
    name: "WhatsappComponent",
    components: { LoadingComponent },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            form: {
                whatsapp_status: null,
                whatsapp_number: null,
                whatsapp_calling_code: null,
                whatsapp_driver: 'standard',
                whatsapp_business_access_token: null,
                whatsapp_business_phone_number_id: null,
                whatsapp_business_waba_id: null,
                whatsapp_business_app_id: null,
                whatsapp_graph_base_url: null,
            },
            enums: {
                activityEnum: activityEnum,
            },
            flag: '',
            isSaving: false,
            onUpdateActive: false,
            errors: {},
        };
    },
    computed: {
        countryCodes: function () {
            return this.$store.getters['countryCode/lists'];
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        phoneNumber(e) {
            return appService.phoneNumber(e);
        },
        change: function (e) {
            this.flag = e.flag_emoji;
            this.form.whatsapp_calling_code = e.calling_code;
        },
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            this.$store.dispatch('countryCode/lists');
            return this.$store.dispatch("whatsapp/lists").then((res) => {
                if (res && res.data && res.data.data) {
                    this.form.whatsapp_calling_code = res.data.data.whatsapp_calling_code;
                    this.form.whatsapp_status = res.data.data.whatsapp_status;
                    this.form.whatsapp_number = res.data.data.whatsapp_number;
                    this.form.whatsapp_driver = res.data.data.whatsapp_driver ?? 'standard';
                    this.form.whatsapp_business_access_token = res.data.data.whatsapp_business_access_token ?? null;
                    this.form.whatsapp_business_phone_number_id = res.data.data.whatsapp_business_phone_number_id ?? null;
                    this.form.whatsapp_business_waba_id = res.data.data.whatsapp_business_waba_id ?? null;
                    this.form.whatsapp_business_app_id = res.data.data.whatsapp_business_app_id ?? null;
                    this.form.whatsapp_graph_base_url = res.data.data.whatsapp_graph_base_url ?? null;
                    this.flag = res.data.data.whatsapp_calling_code;
                }
                
                // Fetch country code to get flag
                if (this.form.whatsapp_calling_code) {
                    this.$store.dispatch('countryCode/callingCode', this.form.whatsapp_calling_code).then(response => {
                        this.flag = response.data.data.flag_emoji;
                        this.form.whatsapp_calling_code = response.data.data.calling_code;
                    }).catch(() => {});
                }
                
                if (showOverlay) {
                    this.loading.isActive = false;
                }
            }).catch((err) => {
                if (showOverlay) {
                    this.loading.isActive = false;
                }
            });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch(() => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        save: function () {
            try {
                this.isSaving = true;
                this.onUpdateActive = true;
                this.$store.dispatch("whatsapp/save", this.form).then((res) => {
                    alertService.successFlip(res.config.method === "put" ?? 0, this.$t("menu.whatsapp_order_setup"));
                    this.$store.dispatch("whatsapp/lists").then((response) => {
                        this.form.whatsapp_calling_code = response.data.data.whatsapp_calling_code;
                        this.form.whatsapp_status = response.data.data.whatsapp_status;
                        this.form.whatsapp_number = response.data.data.whatsapp_number;
                        this.form.whatsapp_driver = response.data.data.whatsapp_driver ?? 'standard';
                        this.form.whatsapp_business_access_token = response.data.data.whatsapp_business_access_token ?? null;
                        this.form.whatsapp_business_phone_number_id = response.data.data.whatsapp_business_phone_number_id ?? null;
                        this.form.whatsapp_business_waba_id = response.data.data.whatsapp_business_waba_id ?? null;
                        this.form.whatsapp_business_app_id = response.data.data.whatsapp_business_app_id ?? null;
                        this.form.whatsapp_graph_base_url = response.data.data.whatsapp_graph_base_url ?? null;
                    }).catch(() => {
                        // Ignore refresh errors after successful save.
                    });
                    this.errors = {};
                    this.isSaving = false;
                    this.onUpdateActive = false;
                }).catch((err) => {
                    this.errors = err.response.data.errors;
                    this.isSaving = false;
                    this.onUpdateActive = false;
                });
            } catch (err) {
                this.isSaving = false;
                this.onUpdateActive = false;
                alertService.error(err);
            }
        }
    }
};
</script>